import {
  Grid,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  useMediaQuery,
  Typography,
} from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { RecordContextProvider, ReferenceField, TextField, useNotify, useRecordContext } from "react-admin";
import { getFile } from "server/components/DownloadFile";

const DocumentsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();
  const notify = useNotify();
  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
      >
        <SectionTitle
          title="Документи"
          paddingY={0}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <TableContainer sx={settings.style.customDatagridStyle}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Тип документ</TableCell>
                <TableCell>Документ</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {record.documents.map((item, index) => (
                <RecordContextProvider
                  key={index}
                  value={item}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        verticalAlign: "middle",
                      }}
                    >
                      <ReferenceField
                        source="documentTypeId"
                        reference={administrationRequests.getPreferenceDocumentTypesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    </TableCell>
                    <TableCell
                      sx={{
                        verticalAlign: "middle",
                      }}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        gap={1}
                        minHeight="100%"
                      >
                        {item.documentIds?.map((docId, idx) => (
                          <Typography
                            key={`documentIds-${idx}`}
                            sx={{
                              textDecoration: "underline",
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                            onClick={() => getFile(docId, notify ? notify : "", "private")}
                          >
                            {`file-${docId}`}
                          </Typography>
                        ))}
                      </Box>
                    </TableCell>
                  </TableRow>
                </RecordContextProvider>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default DocumentsSection;
